import React from 'react';
import { Grid, Paper, Typography, useTheme } from '@mui/material';

interface KpiItem {
  label: string;
  value: React.ReactNode;
  color: string;
  caption?: string;
}

interface Props {
  items: KpiItem[];
}

/**
 * Reusable KPI strip. Matches the visual grammar of StudentReports and
 * StudentLettersTab — Paper + border + tone-coloured big number + uppercase
 * caption underneath.
 */
const FinesKpiStrip: React.FC<Props> = ({ items }) => {
  const theme = useTheme();
  const cols = Math.max(1, Math.min(12, items.length));
  return (
    <Grid container spacing={1.5}>
      {items.map((it, i) => (
        <Grid key={i} size={{ xs: 6, md: Math.floor(12 / cols) || 3 }}>
          <Paper elevation={0} sx={{
            p: 2,
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,
            textAlign: 'center',
            bgcolor: 'background.paper',
            height: '100%',
          }}>
            <Typography variant="h5" fontWeight={700} sx={{ color: it.color, lineHeight: 1.2 }}>
              {it.value}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.4, fontSize: '0.65rem' }}>
              {it.label}
            </Typography>
            {it.caption && (
              <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 0.25, fontSize: '0.65rem' }}>
                {it.caption}
              </Typography>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default FinesKpiStrip;
